import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, Eyebrow } from '../Section';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <Section tone="dark" data-id="element-76" data-mp="1cm7quft1q3gq">
      <Eyebrow data-id="element-77" data-mp="1clfu31nppzov">🎁 And today you’ll also get</Eyebrow>
      <h2 className="mt-2 text-center font-display text-[30px] font-extrabold uppercase leading-[1.03] text-white sm:text-[42px]" data-id="element-78" data-mp="18k4bvh764gqp">
        These 5 premium systems{' '}
        <span className="text-gold-500" data-id="element-79" data-mp="257hchawimxqj">100% free</span>
      </h2>
      <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-80" data-mp="20ba65h07jk82">
        Running a professional repair business isn’t just about having
        documents. It’s about having the right systems to implement them
        quickly — so these 5 additional Premium Systems are included at no extra
        cost.
      </p>

      <div className="mt-8 space-y-5" data-id="element-81" data-mp="fudxr85jdeul">
        {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-gold-500/30 bg-navy-950" data-id="element-82" data-mp="1etnc0adolfnu">
            <div className="bg-gold-500 px-4 py-2" data-id="element-83" data-mp="1js841mis4t17">
              <span className="font-display text-[13px] font-bold uppercase tracking-[0.12em] text-navy-950 sm:text-sm" data-id="element-84" data-mp="15ti31vsua97k">
                🎁 {bonus.number}
              </span>
            </div>

            <div className="flex flex-1 flex-col px-4 py-5 sm:px-6" data-id="element-85" data-mp="w3fce296x7ce">
              <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" className="mx-auto w-full max-w-[260px] drop-shadow-[0_16px_28px_rgba(0,0,0,0.5)] sm:max-w-[300px]" data-id="element-86" data-mp="w12oz9kny4ry" />
              <h3 className="mt-4 font-display text-[23px] font-extrabold uppercase leading-[1.05] text-white sm:text-3xl" data-id="element-87" data-mp="r544hx2gh6wt">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-white/75 sm:text-base" data-id="element-88" data-mp="i34kqx023oq6">
                {bonus.description}
              </p>

              <p className="mt-4 text-[13px] font-bold uppercase tracking-wide text-gold-500" data-id="element-89" data-mp="2ju4rwcbs18id">
                Inside you’ll get:
              </p>
              <ul className="mt-2 space-y-1.5" data-id="element-90" data-mp="2b00647bi2n9p">
                {bonus.points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-91" data-mp="261f4c3glnvj5">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-92" data-mp="25z2e730ouev0" />
                    <span className="text-[14px] leading-snug text-white/90 sm:text-base" data-id="element-93" data-mp="2yr5kei1sl7hw">
                      {point}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-auto flex items-center justify-between gap-3 border-t border-white/10 pt-4 sm:pt-5" data-id="element-94" data-mp="2oqv8r1veo84u">
                <div data-id="element-95" data-mp="1icvtbg6614nd">
                  <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/50" data-id="element-96" data-mp="1dchlnz8h7wpv">
                    Commercial value
                  </p>
                  <p className="font-display text-xl font-bold text-white/60 line-through" data-id="element-97" data-mp="13a47wo9fbz75">
                    {bonus.value}
                  </p>
                </div>
                <span className="rounded-lg bg-green-500 px-3 py-1.5 font-display text-lg font-extrabold uppercase tracking-wide text-navy-950" data-id="element-98" data-mp="1d6gz9fhhy0yq">
                  Free
                </span>
              </div>
            </div>
          </article>)}
      </div>

      <div className="mt-8" data-id="element-99" data-mp="1qy5algjx8len">
        <CTAButton label="Yes — I want all 5 premium systems free" data-id="element-100" data-mp="1qxcct52xx68n" />
      </div>
    </Section>;
}